import background from './background.mjs'
import {
  imgproxySettings,
  mobileImgproxySettings,
  getSKUWithoutPrefix,
  resolvePaceOptionsFromSKU as resolveOptionsFromSKU,
} from './shared.mjs'

import { earsocks } from './vulcans.mjs'

const frameType = 'FF'

export const ghost = {
  id: 'ghost',
  name: 'Ghost Frame',
  hasOptions: false,
  imgproxySettings,
  mobileImgproxySettings,
  opacity: 0.5,
  pathTemplate: `gs://sg360/220520/Ghost Frames/Vulcans/${frameType}/Vulcans ${frameType} Ghost_{nnn}.png`,
}

function resolveOptions(customisedProduct) {
  return {
    earsocks: getSKUWithoutPrefix(customisedProduct.earsocksChoice.sku),
  }
}

export default {
  layers: [background, ghost, earsocks],
  resolveOptions,
  resolveOptionsFromSKU,
}
